import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';

const storedLang = localStorage.getItem('i18nextLng');

// Fetch version from version.txt to use as cache buster
let versionTimestamp = Date.now().toString();
try {
  // This will be executed once when the app loads
  fetch('/version.txt')
    .then((response) => response.text())
    .then((version) => {
      versionTimestamp = version.trim() || Date.now().toString();
    })
    .catch(() => {
      console.warn(
        'Could not load version.txt, using timestamp for cache busting',
      );
    });
} catch (e) {
  console.warn('Error fetching version:', e);
}

i18n
  .use(Backend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    returnNull: false,
    fallbackLng: 'uz',
    lng: storedLang ?? 'uz',
    debug: __IS_DEV__,
    interpolation: {
      escapeValue: false, // not needed for react as it escapes by default
    },
    backend: {
      loadPath: '/locales/{{lng}}/{{ns}}.json',
      queryStringParams: { v: versionTimestamp }, // Use version from version.txt for cache busting
    },
    saveMissing: false,
    react: {
      useSuspense: true,
    },
  });

export default i18n;

// todo setup i18-ally and babel-i18n-extract
